import React from 'react'
import Slider from 'react-rangeslider'
import 'react-rangeslider/lib/index.css'
import './range.css'

const RadiusRange = ({radius, setRadius}) => {
    return (
        <div className="covarage-range">
            <label>Coverage area from location</label>
            <Slider
                className='helo'
                min={0}
                max={250}
                tooltip={true}
                step={1}
                orientation='horizontal'
                value={radius}
                onChange={value => setRadius(value)}
            />
            <div className='indicator-km'>
                <div className="left">0km</div>
                <div className="right">{radius ? radius : 0}km</div>
            </div>
        </div>
    )
}

export default RadiusRange
